export const CHECK = 'CHECK'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const CHANGE_LINES = 'CHANGE_LINES'
export const LOGIN_ROLE = 'LOGIN_ROLE'
export const LOGIN_PLANTS = 'LOGIN_PLANTS'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_PASSWORD = 'LOGIN_PASSWORD'
export const SET_NAV_MINI = 'SET_NAV_MINI'
export const SET_SUB_MENU = 'SET_SUB_MENU'
export const SET_SUB_MENU_DASHBOARD = 'SET_SUB_MENU_DASHBOARD'
export const SET_CLIENT = 'SET_CLIENT'
export const SET_HAS_DASHBOARDS = 'SET_HAS_DASHBOARDS'

export default {
  CHECK,
  LOGIN,
  LOGOUT,
  CHANGE_LINES,
  LOGIN_ROLE,
  LOGIN_PLANTS,
  LOGIN_USER,
  LOGIN_PASSWORD,
  SET_NAV_MINI,
  SET_SUB_MENU,
  SET_SUB_MENU_DASHBOARD,
  SET_CLIENT,
  SET_HAS_DASHBOARDS
}
